<!-- Modern Customer Profile Bar -->
<div class="py-4">
    <div class="max-w-6xl mx-auto px-4">
        <!-- Customer Profile Section -->
        <div *ngIf="!loading && person?.person" class="mb-4">
            <div class="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                <div [routerLink]="['/console/person/profile/',person?.person?.code]"
                     class="flex items-center space-x-4 cursor-pointer hover:opacity-80 transition-opacity">
                    <div class="flex-shrink-0">
                        <img
                            *ngIf="person?.person?.file_selfie"
                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                            [src]="sanitize(person?.person?.file_selfie?.url)"
                            alt="Avatar del cliente"
                        />
                        <img
                            *ngIf="!person?.person?.file_selfie && person?.person?.gender != 'F'"
                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                            [src]="sanitize('../assets/public/images/avatar.png')"
                            alt="Avatar del cliente"
                        />
                        <img
                            *ngIf="!person?.person?.file_selfie && person?.person?.gender == 'F'"
                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                            [src]="sanitize('../assets/public/images/avatara-female.png')"
                            alt="Avatar del cliente"
                        />
                    </div>
                    <div class="flex-1">
                        <h2 class="text-xl font-bold text-gray-900 capitalize hover:text-blue-600 transition-colors">
                            {{person?.person?.name}} {{person?.person?.lastName}}
                        </h2>
                        <div class="flex flex-wrap gap-4 mt-1 text-sm text-gray-600">
                            <div class="flex items-center gap-1">
                                <i class="fas fa-id-card text-blue-600"></i>
                                <span>{{getIdentity(person)}}</span>
                            </div>
                            <div class="flex items-center gap-1">
                                <i class="fas fa-phone text-blue-600"></i>
                                <span>{{getContact(person)}}</span>
                            </div>
                            <div *ngIf="getEmailContact(person)" class="flex items-center gap-1">
                                <i class="fas fa-envelope text-blue-600"></i>
                                <span>{{getEmailContact(person)}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Original Content Unchanged -->
<div class="mt-md-3">
    <div class="max-w-6xl mx-auto px-4">
        <div>
            <div class="row rmt-2" *ngIf="!loading_person">
                <div class="col-12  col-md-8 offset-md-2">

                    <h5 class="mb-1 text-secondary mb-2 text-center">
                        <i class="fas fa-user"></i> Penalidades
                    </h5>

                    <!-- Filtros por Tipo -->
                    <h6 class="text-secondary mb-2 mt-3">
                        <i class="fas fa-filter me-1"></i> Tipo
                    </h6>
                    <!-- Dashboard de filtros con contadores -->
                    <div class="row g-3 mb-3">
                        <div class="col-12 col-md-4 d-flex">
                            <div class="card shadow-sm border-0 cursor-pointer filter-card w-100" [ngClass]="{'selected': filterType==='all'}" (click)="filterType='all'">
                                <div class="card-body d-flex align-items-center justify-content-between h-100">
                                    <div>
                                        <div class="text-secondary small">Todos</div>
                                        <div class="h4 m-0">{{stats.allCount}}</div>
                                    </div>
                                    <div class="text-end">
                                        <div class="text-secondary small">Deuda total</div>
                                        <div class="fw-bold">{{(stats.instDueTotal + stats.personDueTotal) | currency:'USD':'': '1.2-2'}} USD</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 d-flex">
                            <div class="card shadow-sm border-0 cursor-pointer filter-card w-100" [ngClass]="{'selected': filterType==='installment'}" (click)="filterType='installment'">
                                <div class="card-body d-flex align-items-center justify-content-between h-100">
                                    <div>
                                        <div class="text-secondary small">Fees de cuotas</div>
                                        <div class="h4 m-0">{{stats.instCount}}</div>
                                        <div class="small text-warning">Pendientes: {{stats.instPending}}</div>
                                    </div>
                                    <div class="text-end">
                                        <div class="text-secondary small">Deuda</div>
                                        <div class="fw-bold">{{stats.instDueTotal | currency:'USD':'': '1.2-2'}} USD</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 d-flex">
                            <div class="card shadow-sm border-0 cursor-pointer filter-card w-100" [ngClass]="{'selected': filterType==='person'}" (click)="filterType='person'">
                                <div class="card-body d-flex align-items-center justify-content-between h-100">
                                    <div>
                                        <div class="text-secondary small">Fees de persona</div>
                                        <div class="h4 m-0">{{stats.personCount}}</div>
                                        <div class="small text-warning">Pendientes: {{stats.personPending}}</div>
                                    </div>
                                    <div class="text-end">
                                        <div class="text-secondary small">Deuda</div>
                                        <div class="fw-bold">{{stats.personDueTotal | currency:'USD':'': '1.2-2'}} USD</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Filtros por Estatus -->
                    <h6 class="text-secondary mb-2 mt-3">
                        <i class="fas fa-toggle-on me-1"></i> Estatus
                    </h6>
                    <!-- Filtros por estatus -->
                    <div class="row g-3 mb-3">
                        <div class="col-12 col-md-4 d-flex">
                            <div class="card shadow-sm border-0 cursor-pointer filter-card w-100" [ngClass]="{'selected': filterStatus==='pending'}" (click)="filterStatus='pending'">
                                <div class="card-body d-flex align-items-center justify-content-between h-100">
                                    <div>
                                        <div class="text-secondary small">Pendientes</div>
                                        <div class="h4 m-0">{{statusStats.pendingCount}}</div>
                                    </div>
                                    <div class="text-end">
                                        <i class="fas fa-clock fa-2x text-warning"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 d-flex">
                            <div class="card shadow-sm border-0 cursor-pointer filter-card w-100" [ngClass]="{'selected': filterStatus==='completed'}" (click)="filterStatus='completed'">
                                <div class="card-body d-flex align-items-center justify-content-between h-100">
                                    <div>
                                        <div class="text-secondary small">Completados</div>
                                        <div class="h4 m-0">{{statusStats.completedCount}}</div>
                                    </div>
                                    <div class="text-end">
                                        <i class="fas fa-check-circle fa-2x text-success"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 d-flex">
                            <div class="card shadow-sm border-0 cursor-pointer filter-card w-100" [ngClass]="{'selected': filterStatus==='disabled'}" (click)="filterStatus='disabled'">
                                <div class="card-body d-flex align-items-center justify-content-between h-100">
                                    <div>
                                        <div class="text-secondary small">Desactivados</div>
                                        <div class="h4 m-0">{{statusStats.disabledCount}}</div>
                                    </div>
                                    <div class="text-end">
                                        <i class="fas fa-ban fa-2x text-danger"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Botón para generar fee de reactivación — OCULTO: endpoint backend no existe aún -->
                    <div *ngIf="false && canGenerateReactivationFee()" class="alert alert-info d-flex align-items-center justify-content-between mt-3">
                        <div>
                            <i class="fas fa-info-circle me-2"></i>
                            <strong>Cliente inactivo sin fee de reactivación pendiente.</strong>
                            <span class="d-block small mt-1">Puede generar el fee de reactivación para este cliente.</span>
                        </div>
                        <button class="btn btn-primary btn-sm" (click)="generateReactivationFee()">
                            <i class="fas fa-plus-circle me-1"></i>
                            Generar Fee de Reactivación
                        </button>
                    </div>

                </div>
            </div>

            <ng-container *ngIf="!loading && person?.person" class="mt-2">
                <div class="row mt-2" >
                    <div class="col-12  col-md-8 offset-md-2">
                        <!-- Lista: Fees por cuota (installments) - DISEÑO MODERNO -->
                        <ng-container *ngIf="filterType==='all' || filterType==='installment'">
                          <ng-container *ngFor="let row of filteredInstallmentFees">
                            <div class="fee-card-modern" [ngClass]="{ 'fee-card-awaiting-close': getFeeVisualStatus(row) === 'awaiting-close' }">

                              <!-- Header: Monto y Estado -->
                              <div class="fee-header">
                                <div class="fee-amount-section">
                                  <h3>{{row?.amount | currency:'USD':'$':'1.2-2'}}</h3>
                                  <small>{{row?.fee?.concept_deduction?.name}} • {{row?.fee?.code}}</small>
                                </div>
                                <span class="fee-status-badge" [ngClass]="{
                                  'status-complete': getFeeVisualStatus(row) === 'complete',
                                  'status-awaiting-close': getFeeVisualStatus(row) === 'awaiting-close',
                                  'status-pending': getFeeVisualStatus(row) === 'pending'
                                }" [title]="row?.payment_status?.description">
                                  <ng-container [ngSwitch]="getFeeVisualStatus(row)">
                                    <ng-container *ngSwitchCase="'complete'">Pago Completado</ng-container>
                                    <ng-container *ngSwitchCase="'awaiting-close'">Completo · Esperando cierre</ng-container>
                                    <ng-container *ngSwitchDefault>{{row?.payment_status?.name}}</ng-container>
                                  </ng-container>
                                </span>
                              </div>

                              <!-- Grid de información -->
                              <div class="fee-info-grid">
                                <div class="fee-info-item">
                                  <label>Producto</label>
                                  <div class="value">{{row?.params?.product_type?.type || "CREDIT"}}</div>
                                </div>
                                <div class="fee-info-item" style="text-align: right;">
                                  <label>Crédito</label>
                                  <div class="value">{{row?.installment?.invoice?.identifier}}</div>
                                </div>
                                <div class="fee-info-item">
                                  <label>Cuota</label>
                                  <div class="value">{{row?.installment?.order}}</div>
                                </div>
                                <div class="fee-info-item" style="text-align: right;">
                                  <label>Fecha Programada</label>
                                  <div class="value">{{row?.installment?.scheduledPaymentDate | date: 'dd/MM/yyyy'}}</div>
                                </div>
                                <div class="fee-info-item">
                                  <label>Días de Mora</label>
                                  <div class="value" [style.color]="row?.days > 0 ? '#f59e0b' : '#111827'">{{row?.days}}</div>
                                </div>
                                <div class="fee-info-item" *ngIf="row?.due_balance > 0" style="text-align: right;">
                                  <label>Saldo Pendiente</label>
                                  <div class="value" style="color: #f59e0b; font-weight: 600;">
                                    {{row?.due_balance | currency:'USD':'$':'1.2-2'}}
                                  </div>
                                </div>
                                <div class="fee-info-item" *ngIf="row?.totalpaymentReference > 0 && row?.payment_status?.code === 'PaymentPending'" style="grid-column: 1 / -1;">
                                  <label>Por Conciliar</label>
                                  <div class="value" style="color: #f59e0b;">
                                    {{row?.totalpaymentReference | currency:'USD':'$':'1.2-2'}}
                                  </div>
                                </div>
                                <!-- Fecha de creación del fee (siempre que exista) -->
                                <div class="fee-info-item" *ngIf="row?.date" style="grid-column: 1 / -1;">
                                  <label>Fecha de creación</label>
                                  <div class="value">{{ row?.date | date: 'dd/MM/yyyy HH:mm' }}</div>
                                </div>
                                <!-- Fecha de cierre cuando ya está completado -->
                                <div class="fee-info-item" *ngIf="row?.closed_at && getFeeVisualStatus(row) === 'complete'" style="grid-column: 1 / -1;">
                                  <label>Fecha de cierre</label>
                                  <div class="value">{{ row?.closed_at | date: 'dd/MM/yyyy HH:mm' }}</div>
                                </div>
                              </div>

                              <!-- Banner: pagado al 100% pero esperando cierre de cuota -->
                              <div *ngIf="getFeeVisualStatus(row) === 'awaiting-close'" class="fee-awaiting-banner">
                                <i class="fas fa-check-circle me-1"></i>
                                Pago completo. Se marcará como Completado al cerrar la cuota.
                              </div>

                              <!-- Info de desactivación: exonerada / eliminada lógicamente / auto-desactivada. -->
                              <div *ngIf="row?.exonerated || row?.deleted_at || row?.manual_deleted || (row?.payment_status?.code === 'PaymentInactivo' && row?.message)"
                                   style="margin-top: 12px; padding: 12px; background: #fef3c7; border-left: 3px solid #f59e0b; border-radius: 4px;">
                                <ng-container *ngIf="row?.exonerated; else deletedOrAutoRow">
                                  <div style="font-weight: 600; color: #92400e; margin-bottom: 6px;">
                                    <i class="fas fa-shield-alt me-1"></i>
                                    Penalidad exonerada
                                  </div>
                                  <div style="font-size: 13px; color: #78350f; display: grid; gap: 4px;">
                                    <div *ngIf="row?.exonerated_by_user">
                                      <strong>Por:</strong> {{ row?.exonerated_by_user?.name }} {{ row?.exonerated_by_user?.lastName }}
                                      <span *ngIf="row?.exonerated_by_user?.email" style="opacity: 0.8;"> · {{ row?.exonerated_by_user?.email }}</span>
                                    </div>
                                    <div *ngIf="row?.exonerated_at">
                                      <strong>Fecha:</strong> {{ row?.exonerated_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                                    </div>
                                    <div *ngIf="row?.exonerated_ip">
                                      <strong>IP:</strong> {{ row?.exonerated_ip }}
                                    </div>
                                    <div *ngIf="row?.exonerated_reason">
                                      <strong>Razón:</strong> {{ row?.exonerated_reason }}
                                    </div>
                                  </div>
                                </ng-container>
                                <ng-template #deletedOrAutoRow>
                                  <ng-container *ngIf="row?.deleted_at || row?.manual_deleted; else autoDeactivatedRow">
                                    <div style="font-weight: 600; color: #92400e; margin-bottom: 6px;">
                                      <i class="fas fa-trash-alt me-1"></i>
                                      Penalidad eliminada
                                    </div>
                                    <div style="font-size: 13px; color: #78350f; display: grid; gap: 4px;">
                                      <div *ngIf="row?.user_deleted">
                                        <strong>Por:</strong> {{ row?.user_deleted }}
                                      </div>
                                      <div *ngIf="row?.deleted_at">
                                        <strong>Fecha:</strong> {{ row?.deleted_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                                      </div>
                                      <div *ngIf="row?.reason_deleted">
                                        <strong>Razón:</strong> {{ row?.reason_deleted }}
                                      </div>
                                      <div *ngIf="row?.message && !row?.reason_deleted">
                                        <strong>Detalle:</strong> {{ row?.message }}
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-template #autoDeactivatedRow>
                                    <div style="font-weight: 600; color: #92400e; margin-bottom: 6px;">
                                      <i class="fas fa-info-circle me-1"></i>
                                      Penalidad desactivada automáticamente
                                    </div>
                                    <div style="font-size: 13px; color: #78350f;">{{ row?.message }}</div>
                                  </ng-template>
                                </ng-template>
                              </div>

                              <!-- Sección de pagos -->
                              <div class="fee-payments-section" *ngIf="(row?.payments && row?.payments?.length > 0) || (row?.paymentsFeeReferences && row?.paymentsFeeReferences?.length > 0)">
                                <div style="font-size: 13px; font-weight: 600; color: #6b7280; margin-bottom: 8px;">
                                  Pagos Aplicados
                                </div>
                                
                                <!-- Pagos conciliados -->
                                <ng-container *ngFor="let payment of row.payments">
                                  <div class="payment-item">
                                    <div>
                                      <div style="font-weight: 500; color: #111827;">{{ payment?.payment?.paymentMethodId }}</div>
                                      <div class="text-primary" style="font-size: 12px; cursor: pointer;" 
                                           (click)="openBottom(paymentcontainer,{ person_code: row.customer.code, code_payment: payment?.payment?.code})">
                                        {{payment?.payment?.code}}
                                      </div>
                                    </div>
                                    <div style="text-align: right;">
                                      <div style="font-weight: 600; color: #111827;">{{ payment?.amount | currency:'USD':'$':'1.2-2'}}</div>
                                      <span class="badge" [ngClass]="{
                                        'text-bg-success': payment?.payment?.reconciled_payment,
                                        'text-bg-warning': !payment?.payment?.reconciled_payment
                                      }" style="font-size: 10px;">
                                        {{payment?.payment?.reconciled_payment ? 'Aprobado' : 'Por conciliar'}}
                                      </span>
                                    </div>
                                  </div>
                                </ng-container>

                                <!-- Pagos sin conciliar -->
                                <ng-container *ngIf="row?.payment_status?.code === 'PaymentPending'">
                                  <ng-container *ngFor="let payment of row.paymentsFeeReferences">
                                    <div class="payment-item">
                                      <div>
                                        <div style="font-weight: 500; color: #111827;">{{ payment?.payment?.paymentMethodId }}</div>
                                        <div class="text-primary" style="font-size: 12px; cursor: pointer;" 
                                             (click)="openBottom(paymentcontainer,{ person_code: row.customer.code, code_payment: payment?.payment?.code})">
                                          {{payment?.payment?.code}}
                                        </div>
                                      </div>
                                      <div style="text-align: right;">
                                        <div style="font-weight: 600; color: #111827;">{{ payment?.payment?.amount | currency:'USD':'$':'1.2-2'}}</div>
                                        <span class="badge" [ngClass]="{
                                          'text-bg-success': payment?.payment?.reconciled_payment,
                                          'text-bg-warning': !payment?.payment?.reconciled_payment
                                        }" style="font-size: 10px;">
                                          {{payment?.payment?.reconciled_payment ? 'Aprobado' : 'Por conciliar'}}
                                        </span>
                                      </div>
                                    </div>
                                  </ng-container>
                                </ng-container>
                              </div>

                            </div>
                          </ng-container>
                          <div *ngIf="filterType==='installment' && ((filteredInstallmentFees?.length || 0) === 0)" class="mt-3 p-4 bg-white rounded shadow-sm text-center border border-gray-200">
                            <div class="mb-2"><i class="fas fa-inbox fa-2x text-secondary"></i></div>
                            <h6 class="text-secondary mb-1">Sin fees de cuotas</h6>
                            <div class="text-muted small">No hay penalidades asociadas a cuotas para este cliente.</div>
                          </div>
                        </ng-container>

                        <!-- Lista: Fees de persona (Fee_person) - DISEÑO MODERNO -->
                        <ng-container *ngIf="(filterType==='all' || filterType==='person') && filteredPersonFees?.length">
                          <ng-container *ngFor="let pf of filteredPersonFees">
                            <div class="fee-card-modern" [ngClass]="{ 'fee-card-awaiting-close': getFeeVisualStatus(pf) === 'awaiting-close' }">

                              <!-- Header: Monto y Estado -->
                              <div class="fee-header">
                                <div class="fee-amount-section">
                                  <h3>{{pf?.amount | currency:'USD':'$':'1.2-2'}}</h3>
                                  <small>{{pf?.fee?.concept_deduction?.name || pf?.description || 'Fee'}} • {{pf?.fee?.code}}</small>
                                </div>
                                <span class="fee-status-badge" [ngClass]="{
                                  'status-complete': getFeeVisualStatus(pf) === 'complete',
                                  'status-awaiting-close': getFeeVisualStatus(pf) === 'awaiting-close',
                                  'status-pending': getFeeVisualStatus(pf) === 'pending'
                                }">
                                  <ng-container [ngSwitch]="getFeeVisualStatus(pf)">
                                    <ng-container *ngSwitchCase="'complete'">Pago Completado</ng-container>
                                    <ng-container *ngSwitchCase="'awaiting-close'">Completo · Esperando cierre</ng-container>
                                    <ng-container *ngSwitchDefault>{{pf?.payment_status?.name || pf?.payment_status?.code}}</ng-container>
                                  </ng-container>
                                </span>
                              </div>

                              <!-- Grid de información -->
                              <div class="fee-info-grid">
                                <div class="fee-info-item">
                                  <label>Motivo</label>
                                  <div class="value">{{pf?.reason || 'REACTIVATION'}}</div>
                                </div>
                                <div class="fee-info-item" style="text-align: right;">
                                  <label>Fecha</label>
                                  <div class="value">{{pf?.date | date: 'dd/MM/yyyy'}}</div>
                                </div>
                                <div class="fee-info-item">
                                  <label>Días de Mora</label>
                                  <div class="value" [style.color]="pf?.days > 0 ? '#f59e0b' : '#111827'">{{pf?.days || 0}}</div>
                                </div>
                                <div class="fee-info-item" *ngIf="pf?.due_balance > 0" style="text-align: right;">
                                  <label>Saldo Pendiente</label>
                                  <div class="value" style="color: #f59e0b; font-weight: 600;">
                                    {{pf?.due_balance | currency:'USD':'$':'1.2-2'}}
                                  </div>
                                </div>
                                <div class="fee-info-item" *ngIf="pf?.due_balance > 0 && pf?.payment_status?.code === 'PEN'" style="grid-column: 1 / -1;">
                                  <label>Por Conciliar</label>
                                  <div class="value" style="color: #f59e0b;">
                                    {{pf?.due_balance | currency:'USD':'$':'1.2-2'}}
                                  </div>
                                </div>
                                <div class="fee-info-item" *ngIf="pf?.closed_at && getFeeVisualStatus(pf) === 'complete'" style="grid-column: 1 / -1;">
                                  <label>Fecha de cierre</label>
                                  <div class="value">{{ pf?.closed_at | date: 'dd/MM/yyyy HH:mm' }}</div>
                                </div>
                              </div>

                              <!-- Banner: pagado al 100% pero esperando cierre de cuota -->
                              <div *ngIf="getFeeVisualStatus(pf) === 'awaiting-close'" class="fee-awaiting-banner">
                                <i class="fas fa-check-circle me-1"></i>
                                Pago completo. Se marcará como Completado al cerrar la cuota.
                              </div>

                              <!-- Info de desactivación: exonerada / eliminada lógicamente / auto-desactivada. -->
                              <div *ngIf="pf?.exonerated || pf?.deleted_at || pf?.manual_deleted || (pf?.payment_status?.code === 'PaymentInactivo' && pf?.message)"
                                   style="margin-top: 12px; padding: 12px; background: #fef3c7; border-left: 3px solid #f59e0b; border-radius: 4px;">
                                <ng-container *ngIf="pf?.exonerated; else deletedOrAutoPf">
                                  <div style="font-weight: 600; color: #92400e; margin-bottom: 6px;">
                                    <i class="fas fa-shield-alt me-1"></i>
                                    Penalidad exonerada
                                  </div>
                                  <div style="font-size: 13px; color: #78350f; display: grid; gap: 4px;">
                                    <div *ngIf="pf?.exonerated_by_user">
                                      <strong>Por:</strong> {{ pf?.exonerated_by_user?.name }} {{ pf?.exonerated_by_user?.lastName }}
                                      <span *ngIf="pf?.exonerated_by_user?.email" style="opacity: 0.8;"> · {{ pf?.exonerated_by_user?.email }}</span>
                                    </div>
                                    <div *ngIf="pf?.exonerated_at">
                                      <strong>Fecha:</strong> {{ pf?.exonerated_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                                    </div>
                                    <div *ngIf="pf?.exonerated_ip">
                                      <strong>IP:</strong> {{ pf?.exonerated_ip }}
                                    </div>
                                    <div *ngIf="pf?.exonerated_reason">
                                      <strong>Razón:</strong> {{ pf?.exonerated_reason }}
                                    </div>
                                  </div>
                                </ng-container>
                                <ng-template #deletedOrAutoPf>
                                  <ng-container *ngIf="pf?.deleted_at || pf?.manual_deleted; else autoDeactivatedPf">
                                    <div style="font-weight: 600; color: #92400e; margin-bottom: 6px;">
                                      <i class="fas fa-trash-alt me-1"></i>
                                      Penalidad eliminada
                                    </div>
                                    <div style="font-size: 13px; color: #78350f; display: grid; gap: 4px;">
                                      <div *ngIf="pf?.user_deleted">
                                        <strong>Por:</strong> {{ pf?.user_deleted }}
                                      </div>
                                      <div *ngIf="pf?.deleted_at">
                                        <strong>Fecha:</strong> {{ pf?.deleted_at | date: 'dd/MM/yyyy HH:mm:ss' }}
                                      </div>
                                      <div *ngIf="pf?.reason_deleted">
                                        <strong>Razón:</strong> {{ pf?.reason_deleted }}
                                      </div>
                                      <div *ngIf="pf?.message && !pf?.reason_deleted">
                                        <strong>Detalle:</strong> {{ pf?.message }}
                                      </div>
                                    </div>
                                  </ng-container>
                                  <ng-template #autoDeactivatedPf>
                                    <div style="font-weight: 600; color: #92400e; margin-bottom: 6px;">
                                      <i class="fas fa-info-circle me-1"></i>
                                      Penalidad desactivada automáticamente
                                    </div>
                                    <div style="font-size: 13px; color: #78350f;">{{ pf?.message }}</div>
                                  </ng-template>
                                </ng-template>
                              </div>

                              <!-- Botón de pagar -->
                              <div *ngIf="pf?.reason === 'REACTIVATION' && pf?.due_balance > 0 && pf?.payment_status?.code === 'PEN'" style="margin-top: 12px;">
                                <button class="btn btn-success w-100" (click)="goToPayments()" style="border-radius: 8px; padding: 10px; font-weight: 600;">
                                  <i class="fas fa-credit-card me-2"></i>
                                  Pagar {{pf?.due_balance | currency:'USD':'$':'1.2-2'}}
                                </button>
                              </div>

                              <!-- Sección de pagos -->
                              <div class="fee-payments-section" *ngIf="pf?.payments && pf?.payments?.length > 0">
                                <div style="font-size: 13px; font-weight: 600; color: #6b7280; margin-bottom: 8px;">
                                  Pagos Aplicados
                                </div>
                                <ng-container *ngFor="let payment of pf.payments">
                                  <div class="payment-item">
                                    <div>
                                      <div style="font-weight: 500; color: #111827;">{{ payment?.payment?.paymentMethodId }}</div>
                                      <div class="text-primary" style="font-size: 12px; cursor: pointer;" 
                                           (click)="openBottom(paymentcontainer,{ person_code: person?.person?.code, code_payment: payment?.payment?.code})">
                                        {{payment?.payment?.code}}
                                      </div>
                                    </div>
                                    <div style="text-align: right;">
                                      <div style="font-weight: 600; color: #111827;">{{ payment?.amount | currency:'USD':'$':'1.2-2'}}</div>
                                      <span class="badge" [ngClass]="{
                                        'text-bg-success': payment?.payment?.reconciled_payment,
                                        'text-bg-warning': !payment?.payment?.reconciled_payment
                                      }" style="font-size: 10px;">
                                        {{payment?.payment?.reconciled_payment ? 'Aprobado' : 'Por conciliar'}}
                                      </span>
                                    </div>
                                  </div>
                                </ng-container>
                              </div>

                            </div>
                          </ng-container>
                        </ng-container>
                        <div *ngIf="filterType==='person' && ((filteredPersonFees?.length || 0) === 0)" class="mt-3 p-4 bg-white rounded shadow-sm text-center border border-gray-200">
                          <div class="mb-2"><i class="fas fa-user-slash fa-2x text-secondary"></i></div>
                          <h6 class="text-secondary mb-1">Sin fees de persona</h6>
                          <div class="text-muted small">No hay fees vinculados a la persona (ej. reactivación) para este cliente.</div>
                        </div>
                    </div>

                </div>


            </ng-container>


            <div *ngIf="!loading && !loading_person &&  person?.person && ((resp_paymentsCredits?.length || 0) < 1 && (personFees?.length || 0) < 1)" class="col-12  col-md-8 offset-md-2">
                <div class="mt-5 my-3 p-4 bg-white rounded shadow-sm text-center border border-gray-200">
                    <div class="mb-2">
                        <i class="fas fa-inbox fa-2x text-secondary"></i>
                    </div>
                    <h5 class="text-secondary mb-1">Sin penalidades registradas</h5>
                    <div class="text-muted small mb-3">No encontramos fees asociados a cuotas ni fees de persona para este cliente.</div>
                    <div class="d-flex justify-content-center gap-2">
                        <button class="btn btn-outline-primary btn-sm" (click)="filterType='installment'">Ver cuotas</button>
                        <button class="btn btn-primary btn-sm" (click)="filterType='person'">Ver fees de persona</button>
                    </div>
                </div>
            </div>


            <div *ngIf="!loading_person && !person?.person">
                <div>No se encontro person con este id: {{queryParams?.code}}</div>
            </div>


            <ng-container *ngIf="loading_person ||  loading ">
                <div class="w-100 text-center mt-2">
                    <img src="./assets/public/images/loading.gif  " alt=" ">
                </div>
            </ng-container>
        </div>
    </div>

</div>


<ng-template #paymentcontainer let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-10 offset-md-1 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                               Detalle de Pago
                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click'); "></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">
            <div class="row">
                <div class=" col-12 col-md-10 offset-md-1">
                    <div class="text-start">
                        <app-person-payments [code_person]="params_payment['person_code']" [code_payment]="params_payment['code_payment']" (resetStatus)="response($event)"></app-person-payments>

                    </div>
                </div>
            </div>
        </div>
    </div>
  </ng-template>


  <ng-template #fee let-offcanvas>
    <div class="offcanvas-header">
        <div class="container ">
            <div class="row">
                <div class="col-12 col-md-10 offset-md-1 ">
                    <div class="row">
                        <div class="col-10">
                            <div class="text-capitalize h5 text-secondary mt-2 ">
                               Detalle de Fee
                            </div>
                        </div>
                        <div class="col-2 text-end pt-2">
                            <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click'); "></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class=" container">
            <div class="row">
                <div class=" col-12 col-md-10 offset-md-1">
                    <div class="text-start">
                        <app-fee-detail [code_fee]="params_payment['code_fee']"  ></app-fee-detail>

                    </div>
                </div>
            </div>
        </div>
    </div>
  </ng-template>